import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import * as API from "../../Endpoints/Endpoints";

const VajrachakraTable = () => {
    const [allocations, setAllocations] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const itemsPerPage = 5;
    const navigate = useNavigate();

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        axios.get(API.GET_VAJRACHAKRA_API)
            .then((res) => setAllocations(res.data))
            .catch((err) => alert("Failure: " + err));
    };

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const offset = currentPage * itemsPerPage;
    const filteredAllocations = allocations.filter((allocation) =>
        allocation.blade.toLowerCase().includes(searchTerm.toLowerCase()) ||
        allocation.sanskritName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        allocation.meaning.toLowerCase().includes(searchTerm.toLowerCase()) ||
        allocation.symbolism.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const currentPageData = filteredAllocations.slice(offset, offset + itemsPerPage);

 const DeleteVajrachakra = (cardallocid) => {
            if (window.confirm("Are you sure you want to delete this allocation?")) {
                axios({
                    url: API.DELETE_ALLOCATION_API(cardallocid),
                    method: 'DELETE',
                }).then((res) => {
                    alert("Deleted allocation successfully");
                    getData();
                }).catch((err) => {
                    alert("Error: " + err);
                });
            }
        };
    
    const ViewVajrachakra = (vajraid) => {
        navigate(`/viewalloc/${vajraid}`);
    };

    const UpdateVajrachakra = (vajraid) => {
        navigate(`/updatealloc/${vajraid}`);
    };

    return (
        <div className='bg-gray-200 h-auto pb-20 pt-10'>

          <button className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-5 rounded-full flex justify-center items-center mx-auto" onClick={() => navigate("/addvajrachakra")}>
                    Add Data
                </button>
            <div className="max-w-4xl mx-auto pt-4">
                <input
                    type="text"
                    placeholder="Search Terms..."
                    className="w-full px-3 py-2 mb-4 text-gray-700 border rounded-lg focus:outline-none"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>

            <div className="max-w-4xl mx-auto pt-[30px]">
                <div className="overflow-x-auto shadow-md sm:rounded-lg">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-[#e64a32]">
                            <tr>
                                <th className="py-3 px-6 text-center text-white">Blade</th>
                                <th className="py-3 px-6 text-center text-white">Sanskrit Name</th>
                                <th className="py-3 px-6 text-center text-white">Meaning</th>
                                <th className="py-3 px-6 text-center text-white">Symbolism</th>
                                <th className="py-3 px-6 text-center text-white">Action</th>
                                
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {currentPageData.map((allocation) => (
                                <tr key={allocation.bladeId} className="hover:bg-gray-100">
                                    <td className="py-4 px-6 text-gray-900">{allocation.blade}</td>
                                    <td className="py-4 px-6 text-gray-900">{allocation.sanskritname}</td>
                                    <td className="py-4 px-6 text-gray-900">{allocation.meaning}</td>
                                    <td className="py-4 px-6 text-gray-900">{allocation.symbolism}</td>
                                    <td className="py-4 px-6 text-sm font-medium text-center text-gray-900 dark:text-white">
                                        <button onClick={() => ViewVajrachakra(allocation.vajraid)} className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full ml-1">View</button>
                                        <button onClick={() => UpdateVajrachakra(allocation.vajraid)} className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full ml-1 mt-2">Edit</button>
                                        <button onClick={() => DeleteVajrachakra(allocation.vajraid)} className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full ml-1 mt-2">Delete</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

             <div className="flex justify-center mt-4">
                                            <ReactPaginate
                                                previousLabel={"Previous"}
                                                nextLabel={"Next"}
                                                breakLabel={"..."}
                                                pageCount={Math.ceil(filteredAllocations.length / itemsPerPage)}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={5}
                                                onPageChange={handlePageClick}
                                                containerClassName={"pagination"}
                                                subContainerClassName={"pages pagination"}
                                                activeClassName={"active"}
                                                pageClassName={"inline-block px-3 py-1 border border-gray-300 bg-white text-black-700 hover:bg-[#e64a32]"}
                                                pageLinkClassName={"page-link"}
                                                previousClassName={"inline-block px-3 py-1 border border-gray-300 bg-white text-black-700 hover:bg-[#e64a32]"}
                                                previousLinkClassName={"page-link"}
                                                nextClassName={"inline-block px-3 py-1 border border-gray-300 bg-white text-black-700 hover:bg-[#e64a32]"}
                                                nextLinkClassName={"page-link"}
                                                breakClassName={"inline-block px-3 py-1 border border-gray-300 bg-white text-black-700 hover:bg-[#e64a32] break-me"}
                                                breakLinkClassName={"page-link"}
                                                activeLinkClassName={"bg-[#e64a32] text-black"}
                                            />
                                            </div>
        </div>
    );
};

export default VajrachakraTable;
